'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.noValue = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _isUndefined = require('lodash/isUndefined');

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _templates = require('../templates');

var _odataUri = require('../../utils/odata-uri');

var _event = require('../../core/event');

var _event2 = _interopRequireDefault(_event);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = require('debug')('linksoft:datatables:StringColumn');

var noValue = exports.noValue = '-';

var StringColumn = function () {
	_createClass(StringColumn, [{
		key: 'api',


		/**
   * DataTable API.
   * @type {null}
   */
		get: function get() {
			return this._api || (this._api = (0, _jquery2.default)(this.table).DataTable());
		}
	}, {
		key: 'column',
		get: function get() {
			return this.api.column(this.index);
		}
	}, {
		key: 'sourceProp',
		get: function get() {
			return this.options.data || this.options.name;
		}
	}, {
		key: 'orderByProp',
		get: function get() {
			return this.sourceProp;
		}
	}, {
		key: 'filterByProp',
		get: function get() {
			return this.sourceProp;
		}
	}]);

	function StringColumn(tableElement, options, index) {
		_classCallCheck(this, StringColumn);

		this._lastFilterValue = '';
		this.table = null;
		this.options = null;
		this.index = 0;

		this.table = tableElement;
		this.options = options;
		this.index = index;
	}

	// ----------- CELL RENDERING -----------------------
	/**
  * Basic implementation of displaying data. Only used when template option is not set.
  * @param value
  * @returns {*|string}
  */


	_createClass(StringColumn, [{
		key: 'displayValue',
		value: function displayValue(value) {
			var isArray = this.options.isArray;

			if (value === null || (0, _isUndefined2.default)(value) || value === '' || isArray && !value.length) return noValue;
			if (isArray) {
				return value.join(', ');
			}
			return value;
		}

		// ------------ EDITOR --------------------------

		/**
   * Returns input element for text editing.
   * @param value Original value.
   * @returns {string} HTML markup.
   */

	}, {
		key: 'createEditor',
		value: function createEditor(value, id) {
			return (0, _jquery2.default)('<input class="table-input" type="text" />').val(value || '').get(0);
		}

		/**
   * Returns value from table cell editor input element.
   * @param cellElement {HTMLElement}
   * @returns {string}
   */

	}, {
		key: 'getEditorValue',
		value: function getEditorValue(cellElement) {
			return (0, _jquery2.default)(cellElement).find('.table-input').val();
		}
	}, {
		key: 'onEditorCreated',
		value: function onEditorCreated(cellElement) {
			cellElement.find('input:first').focus();
		}
	}, {
		key: 'buildPatchData',
		value: function buildPatchData(value) {
			var data = {};
			var src = this.column.dataSrc();
			data[src] = value;
			return data;
		}

		// -------------- FILTERS --------------------

	}, {
		key: 'createFilter',
		value: function createFilter() {
			return '<input type="text" class="form-control input-sm table-filter" />';
		}

		/**
   * Extracts value from filter input to be used as actual filter value.
   */

	}, {
		key: 'getFilterValue',
		value: function getFilterValue() {
			var $target = this.column.filter().find('.table-filter');
			if ($target.length === 2) {
				var val = (0, _jquery2.default)($target.get(0)).val() + "~" + (0, _jquery2.default)($target.get(1)).val();
				return val !== '~' ? val : '';
			}
			return $target.val() || "";
		}

		/**
   * Generates OData filter expression for current column filter.
   */

	}, {
		key: 'getFilterExpression',
		value: function getFilterExpression() {
			var fieldName = this.filterByProp;
			var value = this.column.search();
			if (!value) return null;
			return this.buildFilterExpression(fieldName.replace(/\./, '/'), value);
		}
	}, {
		key: 'buildFilterExpression',
		value: function buildFilterExpression(fieldName, value) {
			return this.options.isArray ? this.options.useDollarSearch ? _odataUri.filters.anyStartsOrEndsWith(fieldName, value) : _odataUri.filters.anyContains(fieldName, value) : this.options.useDollarSearch ? _odataUri.filters.startsOrEndsWith(fieldName, value) : _odataUri.filters.contains(fieldName, value);
		}

		/**
   * Returns text to be displayed as filtered value. Can differ from actual filtered value,
   * e.g. lookup column shows name but filters by id.
   */

	}, {
		key: 'getFilterText',
		value: function getFilterText() {
			return this.getFilterValue();
		}

		/**
   * Set filter value to filter input(s).
   * Override this, to be consistent with createFilter function output.
   * @param value
   */

	}, {
		key: 'setFilterValue',
		value: function setFilterValue(value) {
			var inputs = this.column.filter().find('input.table-filter');
			var values = value.split('~', 2);

			if (inputs.length > 0) {
				(0, _jquery2.default)(inputs.get(0)).val(values[0] || '');
			}
			if (inputs.length > 1) {
				(0, _jquery2.default)(inputs.get(1)).val(values[1] || '');
			}
		}

		/**
   * Override this to perform custom element focus when filter box opens.
   */

	}, {
		key: 'setFilterFocus',
		value: function setFilterFocus() {
			this.column.filter().find('input:first').focus();
		}
	}, {
		key: 'showFilterButton',
		value: function showFilterButton() {
			return true;
		}
	}, {
		key: 'onFilterRendered',
		value: function onFilterRendered() {}
	}, {
		key: 'autoCloseFilterBox',
		value: function autoCloseFilterBox() {
			return true;
		}

		/**
   * This is the method which is actually passed to DataTables column option 'render' callback.
   * @param value
   * @param type
   * @param row
   * @param meta
   */

	}, {
		key: 'render',
		value: function render(value, type, row, meta) {
			var _options = this.options,
			    template = _options.template,
			    templateArgs = _options.templateArgs,
			    formatString = _options.formatString;

			if (template) {
				var templateFunc = template;
				if (typeof templateFunc === 'string') {
					templateFunc = (0, _templates.getTemplate)(templateFunc);
				}
				if (typeof templateFunc === 'function') {
					var e = {
						column: this.column,
						api: this.api,
						meta: meta,
						value: value,
						type: type,
						data: row,
						formatString: formatString
					};
					var args = [e].concat(_toConsumableArray(templateArgs || []));
					return templateFunc.apply(row, args) || noValue;
				}
			}
			return this.displayValue(value, row);
		}
	}, {
		key: 'exportRender',
		value: function exportRender(value, row, meta) {
			return this.render(value, 'display', row, meta);
		}

		/**
   *
   */

	}, {
		key: 'renderFilter',
		value: function renderFilter() {
			if (this.options.searchable === false) return;

			var $wrapper = (0, _jquery2.default)(wrapper);
			if (!this.showFilterButton()) {
				$wrapper.find('.filter-box-wrap button').remove();
			}

			var f = this.createFilter();
			if (!f) return;

			var $box = $wrapper.find('.filter-box-wrap');
			$box.prepend(f);

			this.column.filter().html($wrapper);

			this.onFilterRendered();
		}

		/**
   *  Displays filtered text and updates UI as appropriate
   */

	}, {
		key: 'displayFilter',
		value: function displayFilter() {
			var value = this.column.search();
			if (this._lastFilterValue == value) return;

			this._lastFilterValue = value;
			this.setFilterValue(value);

			var text = this.getFilterText();
			var filterCell = this.column.filter();

			// display filter text
			filterCell.find('.filter-string').text(text);
			filterCell.toggleClass('filter-active', !!value);
		}
	}]);

	return StringColumn;
}();

exports.default = StringColumn;


var wrapper = '<div class="filter-wrapper">\n\t<div class="filter-display">\n    <i class="fa fa-remove fa-filter-clear filter-closer"></i>\n    <div class="filter-string"></div>\n\t\t<i class="fa fa-filter filter-opener"></i>\n\t</div>\n\t<div class="filter-box-wrap hide">\n\t\t<button class="btn btn-grey">\n\t\t\t<i class="fa fa-search"></i>\n\t\t</button>\n\t</div>\n</div>';

function closeAllFilters() {
	(0, _jquery2.default)('.dataTable thead th').removeClass('filter-opened');
	(0, _jquery2.default)('.dataTable thead th .filter-box-wrap').addClass('hide');

	log('filter boxes closed');
}

function getRenderer(element) {
	var api = (0, _utils.getDataTableApi)(element);
	var column = api.columnByFilter(element);
	return column.renderer();
}

function applyFilter(element) {
	var renderer = getRenderer(element);
	// apply filter
	var value = renderer.getFilterValue();
	renderer.column.search(value).draw();
	if (renderer.autoCloseFilterBox()) {
		closeAllFilters();
	}
	return false;
}

// click outside of filter box should close the box
(0, _jquery2.default)(document).on('click', function (e) {
	if ((0, _jquery2.default)(e.target).closest('.filter-wrapper').length) return;
	closeAllFilters();
});

// clear filter button handler
(0, _jquery2.default)(document).on('click', 'table.dataTable .filter-closer', function () {
	(0, _utils.getDataTableApi)(this).columnByFilter(this).search('').draw();
});

// open filter box
(0, _jquery2.default)(document).on('click', 'table.dataTable .filter-wrapper .filter-display', function (e) {
	var $target = (0, _jquery2.default)(this);
	if ((0, _jquery2.default)(e.target).is('.filter-closer')) return;

	var api = (0, _utils.getDataTableApi)($target);
	var $th = $target.closest('th');
	var isOpen = $th.is('.filter-opened');
	var renderer = api.columnByFilter($target).renderer();

	closeAllFilters();

	$th.addClass('filter-opened');
	$th.find('.filter-box-wrap').removeClass('hide');

	if (!isOpen) {
		renderer.setFilterFocus();
	}
	log('filter box opened');
});

// apply filter on filter confirm button click
(0, _jquery2.default)(document).on('click', 'table.dataTable .filter-wrapper button', function () {
	return applyFilter(this);
});

// apply filter on select value change
(0, _jquery2.default)(document).on('change', 'table.dataTable .filter-wrapper select.table-filter', function () {
	return applyFilter(this);
});

// apply filter on press enter
(0, _jquery2.default)(document).on('keydown', 'table.dataTable .filter-wrapper .filter-box-wrap', function (e) {
	if (e.which === 13) {
		// enter
		applyFilter(this);
		return false;
	}
	if (e.keyCode === 27) {
		// esc
		getRenderer(this).displayFilter();
		closeAllFilters();
	}
	return true;
});

// // updates UI when search event occurs
// $(document).on('search.dt', function(e, settings){
// 	log('table search event triggered');
// 	const api = $.fn.dataTable.Api(settings);
//
// 	// TODO: api.columns().search();
// });

// display filter value / text on headerCallback
_event2.default.on('linksoft.datatables.headerCallback', function (e, data) {
	var api = (0, _utils.getDataTableApi)(data);
	api.columns().every(function () {
		this.renderer().displayFilter();
	});

	log('table header filters displayed');
});


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/data-tables/renderers/StringColumn.js
// module id = 419
// module chunks = 1